import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * NotifyService provides notification request API services
 */
class NotifyService {

    addRequest = (data) => {
        //console.log('NotifyService.addRequest() data:', data)
        return new Promise((resolve, reject) => {
            const url = `/api/v2/notify/zone`
            ky.post(url, {json: data}).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new NotifyService();

export default instance;